"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProjectSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var select_1 = require("@hiyllo/ux/select");
var use_create_personal_project_1 = require("../hooks/use-create-personal-project");
var use_my_projects_1 = require("../hooks/use-my-projects");
exports.ProjectSelect = react_1["default"].memo(function ProjectSelect(props) {
    var _a, _b;
    var _c = (0, use_my_projects_1.useMyProjects)(), projects = _c.projects, projectsQuery = _c.projectsQuery;
    var createPersonalProjectMutation = (0, use_create_personal_project_1.useCreatePersonalProject)({
        querySideEffects: [projectsQuery]
    });
    var createPersonalProjectRef = react_1["default"].useRef(false);
    react_1["default"].useEffect(function () {
        if (projects !== null &&
            projects.length === 0 &&
            !projectsQuery.isLoading &&
            !createPersonalProjectMutation.isLoading &&
            !createPersonalProjectRef.current) {
            createPersonalProjectRef.current = true;
            void createPersonalProjectMutation.call(null);
        }
    }, [createPersonalProjectMutation, projects, projectsQuery.isLoading]);
    var options = react_1["default"].useMemo(function () {
        return props.disallowNullSelection === true
            ? (projects !== null && projects !== void 0 ? projects : []).map(function (p) { return ({
                label: p.name,
                value: p.uuid
            }); })
            : __spreadArray([
                {
                    value: null,
                    label: "<No Project>"
                }
            ], (projects !== null && projects !== void 0 ? projects : []).map(function (p) { return ({
                label: p.name,
                value: p.uuid
            }); }), true);
    }, [projects, props.disallowNullSelection]);
    var value = props.projectUUID == null
        ? props.disallowNullSelection
            ? (_b = (_a = options[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null
            : null
        : props.projectUUID;
    react_1["default"].useEffect(function () {
        if (value !== props.projectUUID &&
            props.projectUUID == null &&
            props.disallowNullSelection === true &&
            value !== null) {
            props.setProjectUUID(value);
        }
    }, [props, value]);
    return ((0, jsx_runtime_1.jsx)(select_1.Select, { fullWidth: true, options: options, value: value, onChangeValue: function (option) { return props.setProjectUUID(option); } }));
});
